import { Component, EventEmitter, Output } from "@angular/core";
import { UserStatsCategory } from "@ponder-features/user/stats/user-stats-category";

@Component({
    template: "",
    standalone: false
})
export class StatsEvents {
    @Output()
    public categorySelected: EventEmitter<UserStatsCategory> = new EventEmitter();
}